import React, { useCallback } from 'react';
import { withTranslation } from 'react-i18next';
import { useRouteMatch, withRouter } from 'react-router-dom';
import { push } from '../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import AppIcon from '../../components/AppIcon';
import queryString from 'query-string';

import { saveBook } from '../../modules/book';

import ContentAutoSaveButton from './contentAutoSaveButton';
import SidebarToggler from './sidebarToggler';
import styled from 'styled-components';
import ChatMenuItem from './chatMenuItem';

const TitleMenuItemWrapper = styled.div.attrs({className: 'item'})`
  flex: 1 2 300px;
  max-width: 40%;
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  span:last-child { overflow: hidden; text-overflow: ellipsis; }
`;

const InfoDropdown = styled.details`
  position: relative;
  summary {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 44px;
    min-height: 44px;
    list-style: none;
    cursor: pointer;
  }
  summary::-webkit-details-marker { display: none; }
  summary:focus-visible { outline: 2px solid var(--br-focus); outline-offset: 2px; }
  &[open] > div {
    position: absolute;
    right: 0;
    top: 100%;
    z-index: 10;
    min-width: max-content;
    padding: 0.5rem;
    background: var(--br-surface, white);
    border: 1px solid var(--br-border, #ccc);
    border-radius: 0.5rem;
  }
`;

const EditorActions = styled.div`
  display: flex;
  flex: none;
  align-items: center;
  gap: var(--br-space-1);
  margin-left: auto;
  min-height: 44px;
`;

export const EditBookContextMenu = ({
  currentBook,
  currentContentVersion,
  currentPartTitle,

  t,
}) => {
  const match = useRouteMatch('/books/:bookId/content/v:versionNumber/:partId');
  const getReaderLink = useCallback(() => {
    if (match && currentBook?._id) {
      const {
        params: { partId },
      } = match;
      return `/read?${queryString.stringify({
        book: currentBook._id,
        currentContentVersionId: currentContentVersion?._id,
        currentPartId: partId,
        viewAsReader: true,
      })}`;
    }
    return `/read?${queryString.stringify({
      book: currentBook._id,
      viewAsReader: true,
    })}`;
  }, [currentBook?._id, currentContentVersion?._id, match]);
  if (!currentBook) {
    return null;
  }
  return (
    <>
      <SidebarToggler />
      <TitleMenuItemWrapper>
        <TitleWrapper>
          <AppIcon name="book" aria-hidden='true' />
          <span>{currentPartTitle || currentBook?.title || ''}</span>
        </TitleWrapper>
      </TitleMenuItemWrapper>
      <EditorActions>
        <ChatMenuItem />
        <InfoDropdown onKeyDown={event => {
          if (event.key === 'Escape') event.currentTarget.removeAttribute('open');
        }}>
          <summary aria-label={t('MoreInfo', { defaultValue: 'More information' })}>
            <AppIcon name="info circle" aria-hidden="true" />
          </summary>
          <div>
            <a className="br-button br-button--primary br-button--small" href={getReaderLink()} target="_blank" rel="noreferrer">
              <AppIcon name="eye" aria-hidden="true" /> {t('ViewAsReader')}
            </a>
          </div>
        </InfoDropdown>
        <ContentAutoSaveButton position="right" />
      </EditorActions>
    </>
  );
};

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  userProfile: state.user.userProfile,
  currentBook: state.book.currentBook,
  currentContentVersion: state.book.currentContentVersion,
  currentPartTitle: state.book.currentPartTitle,
  currentSpineIndex: state.readerApp.currentSpineIndex,
  pendingBookChanges: state.book.pendingBookChanges,
  pendingPartChanges: state.book.pendingPartChanges,
  saveButton: state.book.saveButton,
  percentagePassed: state.readerApp.percentagePassed,
  sidebarVisible: state.app.sidebarVisible,
  fontSizes: state.app.fontSizes,
  searchTerm: state.betaOpportunities.searchTerm,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      saveBook,
      changePage: newPage => push(newPage),
    },
    dispatch
  );

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(EditBookContextMenu))
);
